export function isArabicOnly(text = "") {
  // remove spaces & punctuation before check
  const cleaned = text.replace(/[\s.,!?;:()[\]{}"'-]/g, "");

  // Arabic Unicode block only
  return /^[\u0600-\u06FF]+$/.test(cleaned);
}
